import { TableBody } from './table-body'
import { TableHeader } from './table-header'
import { TableRow } from './table-row'

export const SearchTable = {
  Body: TableBody,
  Header: TableHeader,
  Row: TableRow,
}
